import React from "react";

const FALLBACK_LIMIT_OPTIONS = [50, 100, 250, 500, 1000];
const FALLBACK_ORDER_OPTIONS = [
  { value: "TOTAL", label: "TOTAL" },
  { value: "NO_OP", label: "NO_OP" }
];
const FALLBACK_PERSON_OPTIONS = [
  { value: "FISICA", label: "FISICA" },
  { value: "MORAL", label: "MORAL" }
];

export default function QueryBuilder({ filters, metadata, onChange, onRun, disabled = false }) {
  const tableOptions = metadata?.tableOptions || [];
  const limitOptions = metadata?.limitOptions || FALLBACK_LIMIT_OPTIONS;
  const orderOptions = metadata?.orderOptions || FALLBACK_ORDER_OPTIONS;
  const personOptions = metadata?.personOptions || FALLBACK_PERSON_OPTIONS;

  return (
    <section className="builder-card">
      <div className="builder-grid">
        <div className="field">
          <label>Tabla</label>
          <select
            value={filters.table}
            onChange={(e) => onChange("table", e.target.value)}
            disabled={disabled}
          >
            {tableOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>

        <div className="field">
          <label>Top N</label>
          <select
            value={filters.limit}
            onChange={(e) => onChange("limit", Number(e.target.value))}
            disabled={disabled}
          >
            {limitOptions.map((value) => (
              <option key={value} value={value}>
                {value}
              </option>
            ))}
          </select>
        </div>

        <div className="field">
          <label>Ordenar por</label>
          <select
            value={filters.orderBy}
            onChange={(e) => onChange("orderBy", e.target.value)}
            disabled={disabled}
          >
            {orderOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>

        <div className="field">
          <label>Tipo de persona</label>
          <select
            value={filters.tipoPersona}
            onChange={(e) => onChange("tipoPersona", e.target.value)}
            disabled={disabled}
          >
            {personOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>

        <div className="field actions">
          <button className="primary-button" type="button" onClick={onRun} disabled={disabled}>
            {disabled ? 'Consultando...' : 'Consultar'}
          </button>
        </div>
      </div>
    </section>
  );
}
